/**
 * @Description 便签类，包括各种热点类以及热点管理类
 * @Author Kida
 * @Date 2020-10-11
 * @Version 1.0
 */

import * as THREE from 'three'
import * as CanvasUtil from './CanvasUtil'
import { config } from './config'
import { strToNumberArray } from './Utils'

export class NameBuildingTag {
  constructor (id, name, pos) {
    this.id = id
    this.name = name
    this.position = pos

    // const size = { x: 0, y: 0 }
    const canvas = document.createElement('canvas')
    CanvasUtil.drawRoundText(canvas, name)

    const tex = new THREE.CanvasTexture(canvas)
    tex.wrapS = THREE.ClampToEdgeWrapping
    tex.wrapT = THREE.ClampToEdgeWrapping
    tex.needsUpdate = true

    const material = new THREE.SpriteMaterial({ map: tex, transparent: true })
    material.sizeAttenuation = false
    material.blending = THREE.CustomBlending
    material.blendDst = THREE.OneMinusSrcAlphaFactor
    material.blendSrc = THREE.OneFactor

    const obj = new THREE.Sprite(material)
    obj.center.set(0.5, 0.5)
    obj.scale.set(canvas.width / canvas.height / 2, 1 / 2, 1).multiplyScalar(0.075)
    obj.position.copy(pos)

    this.defaultScale = obj.scale.clone()

    this.obj = obj
  }

  get visible () {
    return this.obj.visible
  }

  set visible (value) {
    this.obj.visible = value
  }

  resize (ratio) {
    this.obj.scale.copy(this.defaultScale).multiplyScalar(ratio)
  }
}

export class BuildingTagSet {
  constructor () {
    this.root = new THREE.Group()
    this.id2BuildingTag = {}
    this.scaleRatio = 1
  }

  /**
   * 初始化设置
   * @param {boolean} showMark 是否显示标记
   * @memberof BuildingTagSet
   */
  init (showMark) {
    this.showMark = showMark
  }

  /**
   * 添加标记
   * @param {NameBuildingTag} bt 被添加的标记
   */
  addBuildingTag (bt) {
    this.id2BuildingTag[bt.id] = bt
    this.root.add(bt.obj)
  }

  /**
   * 移除标记
   * @param {NameBuildingTag} bt 被移除的标记
   */
  removeBuildingTag (bt) {
    delete this.id2BuildingTag[bt.id]
    this.root.remove(bt.obj)
  }

  /**
   * 获取id对应的标记
   * @param {string} id 标记id
   * @returns {NameBuildingTag} 获得的标记
   * @memberof BuildingTagSet
   */
  getBuildingTag (id) {
    return this.id2BuildingTag[id]
  }

  tagResize (ratio) {
    // console.log(t)
    for (var b in this.id2BuildingTag) {
      this.id2BuildingTag[b].resize(ratio)
    }
  }

  get visible () {
    return this.root.visible
  }

  set visible (value) {
    this.root.visible = this.showMark && value
  }
}

/**
 * 使用配置初始建筑标记
 * @param {BuildingTagSet} bts 建筑标记集合
 * @param {object} setting 配置信息
 */
export function initBuildingTags (bts, isShowMark, tagMessage) {
  // console.log(setting)
  bts.init(isShowMark)
  // 添加标记
  for (const msg of tagMessage) {
    const pos = new THREE.Vector3().fromArray(strToNumberArray(msg.viewAngle))
    bts.addBuildingTag(
      new NameBuildingTag(
        msg.markerId, msg.markerName, pos
      ))
  }
}
